module.exports = __webpack_public_path__ + "media/images/LED-3-bb867c2ae1063d5cedd3c9de87596be1.png";